import { User } from "@/@types/sintegrada/User";
import { getSintegradaServerApi } from "@/services/api";

type ProfessionalParams = {
	professionalName?: string;
	uf: string;
	ibgeCode: string;
	cnes?: string;
	cbos?: string[];
};

export async function getProfessionals(params: ProfessionalParams) {
	const response = await getSintegradaServerApi().get<User[]>(
		`/users`,
		params
	);
	return response.data || [];
}
